import React from "react";

import {FIELD_TYPE, tabKeys, TT_PHIEU_VTYT} from "types/enums";

import { DataFormField } from "types/models/input-field-type";

import {ColumnProps} from "../../../../../types/models";
import {listGender} from "../../../../../data/list";
import {trangThaiPKOptions} from "../../../../../assets/constants/select-catagory-options";
import { formatToCurrencyType } from "helper/common";

const { INPUT, DATE, COMBO_BOX,DATE_DISABLE_NO_DAY, AUTO_COMPLETE, CODE, NUMBER } = FIELD_TYPE;

const listStatus = [
  {
    value: 0,
    label: "Đang lên kế hoạch",
  },
  {
    value: 1,
    label: "Đang đào tạo",
  },
  {
    value: 2,
    label: "Đã kết thúc",
  },

];
const listDaoTaoLe = [
  {
    value: 1,
    label: "Có",
  },
  {
    value: 0,
    label: "Không",
  },
];
const listMonths = [];
for (let month = 1; month <= 12; month++) {
  listMonths.push({
    value: month,
    label: `Tháng ${month}`,
  });
}
const  allColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    disabledCheck: true,
    align:"center",
    fixed: "left",
    width:  140,
    isResizable: true,
  },
  {
    title: "Tên khóa ĐT",
    key: "tenKhoaDaoTao",
    show: true,
    dataIndex: "tenKhoaDaoTao",
    isResizable: true,
    align: 'left',
    fixed:"left",
  },
  {
    title: "Mục đích",
    key: "mucDich",
    show: true,
    dataIndex: "mucDich",
    isResizable: true,
    align: 'left',
  },
  {
    title: "ĐT từ ngày",
    key: "daoTaoTuNgayDto",
    show: true,
    dataIndex: "daoTaoTuNgayDto",
    isResizable: true,
    align: 'center',
  },
  {
    title: "ĐT đến ngày",
    key: "daoTaoDenNgayDto",
    show: true,
    dataIndex: "daoTaoDenNgayDto",
    isResizable: true,
    align: 'center',
  },
  {
    title: "Tổng số NV",
    key: "tongSoNV",
    show: true,
    dataIndex: "tongSoNV",
    isResizable: true,
    align: 'right',
  },
  {
    title: "Tổng CPĐT",
    key: "tongSoCPDT",
    show: true,
    dataIndex: "tongSoCPDT",
    isResizable: true,
    align: 'right',
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
  },
  },
  {
    title: "Trạng thái",
    key: "trangThaiDto",
    show: true,
    dataIndex: "trangThaiDto",
    isResizable: true,
    align: 'left',

  },
  {
    title: "Tác vụ",
    dataIndex: "action",
    show: true,
    align: "center",
    fixed: "right",
    width: 160,
    key: "action",
  },




];

const itemsInputField: DataFormField[] = [
  {
    type: INPUT,
    name: "donViDaoTao",
    label: "Đơn vị đào tạo",
    expand: false,
  },
  {
    type: INPUT,
    name: "maDaoTao",
    expand: false,
    label: "Mã đào tạo",
  },
  {
    type: INPUT,
    name: "tenKhoaDaoTao",
    expand: false,
    label: "Tên khóa ĐT",
    options: listGender,
  },
  {
    type: DATE_DISABLE_NO_DAY,
    name: "daoTaoTuNgayDto",
    expand: false,
    label: "ĐT từ ngày",
    disableDate:false,
  },
  // {
  //   type: INPUT,
  //   name: "daoTaoDenNgay",
  //   expand: false,
  //   label: "Vị trí ứng tuyển",
  // },
  {
    type: DATE_DISABLE_NO_DAY,
    name: "daoTaoDenNgayDto",
    expand: false,
    label: "ĐT đến ngày",
    disableDate:false,
  },
  {
    type: COMBO_BOX,
    name: "trangThai",
    expand: false,
    label: "Trạng thái",
    options: listStatus,
  },
  {
    type: COMBO_BOX,
    name: "daoTaoLeSearch",
    expand: false,
    label: "Đào tạo lẻ",
    options: listDaoTaoLe,
  },
];

export { allColumns, itemsInputField };
